import fetch from 'node-fetch';
import {APISRC} from '../constants/Fetch'

class APIError {
  constructor(statusText, status = 0, response = {}) {
    this.status = status;
    this.statusText = statusText;
    this.response = response;
  }

  toString() {
    return `${this.statusText}`;
  }
}

const isUrlAbsolute = new RegExp('^(?:[a-z]+:)?//', 'i');

const defaultInit = {
  mode: 'cors',
  headers: {
    'Content-Type': 'application/json',
  },
};

const requestsCache = {};

const jsonRequest = (url, requestInit) => {
  const isModifyingMethod = !['GET', 'HEAD'].includes(requestInit.method);

  if (isModifyingMethod && url in requestsCache && Date.now() - requestsCache[url] < 2000) {
    requestsCache[url] = Date.now();

    return Promise.reject(
      new APIError('Повторная отправка запроса', 0, { json: () => Promise.reject() })
    );
  }

  if (isModifyingMethod) {
    requestsCache[url] = Date.now();
  }

  return fetch(url, requestInit)
    .catch(() => {
      throw new APIError('Не получен ответ от сервера', 0, { json: () => Promise.reject() });
    })
    .then(response => {
      if (!response.ok) {
        throw new APIError(response.statusText, response.status, response);
      }

      return response;
    })
    .then(response => response.json());
};

const jsonGet = (path, queryArgs) => {
  let url = null;
  if (isUrlAbsolute.test(path)) {
    url = path;
  } else {
    url = APISRC + path;
  }
  const requestInit = {
    ...defaultInit,
    ...{
      method: 'GET',
    },
  };
  let urlWithArgs = url;
  if (queryArgs) {
    urlWithArgs += `?${Object.keys(queryArgs)
      .map(key => `${key}=${queryArgs[key]}`)
      .join('&')}`;
  }
  return jsonRequest(urlWithArgs, requestInit);
};

const errorHandler = error => {
  const message = `Не удалось получить данные из-за ошибки:`;

  if (error.response) {
    error.response
      .json()
      .then(errorMessage => {
        console.log(`${message}\n${errorMessage}`);
      })
      .catch(() => {
        console.log(`${message}\n${error}`);
      });
  }
  throw error;
};

export { jsonGet, errorHandler };



// WEBPACK FOOTER //
// ./src/utils/Request.js